export const MAIN_PALETTE = {
  main: "#000000",
  productFirstElementBackground: "#FFFFFF",
  productSecondElementBackground: "#F6F6F6",
  edgingBackground: "#cccdd0",
  logoBackground: "#101649",
};

export const TEXT_PALETTE = {
  main: "#000000",
  linkText: "#000000",
  navigationLink: "#FFFFFF",
  active: "#daa520",
};
